import { useTranslation } from "react-i18next";
import { useStore } from "../../store/globalState";
import { NotificationBellIcon, solidFill } from "./NotificationBellIcon";
import { useNovuInbox } from "./NovuInboxProvider";
import "./NotificationsBell.css";

export function NotificationsBell() {
  const inbox = useNovuInbox();
  const { t } = useTranslation();
  const { title, backgroundBtn, textColorBtn } = useStore().theme.whiteView;
  if (!inbox?.enabled) return null;

  return (
    <button
      type="button"
      className="notifications-bell"
      aria-label={t("notifications.bellLabel")}
      onClick={(event) => {
        event.stopPropagation();
        inbox.setOpen(true);
      }}
    >
      <NotificationBellIcon size={24} color={solidFill(title)} />
      {inbox.unread > 0 ? (
        <span
          className="notifications-bell-badge"
          style={{ background: backgroundBtn, color: textColorBtn }}
        >
          {inbox.unread}
        </span>
      ) : null}
    </button>
  );
}
